import { Node } from "#/decision_tree_viewer/models/node";

import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";

const { processText } = useSnippetProcessor();

export class BroadcastNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "BroadcastNode",

      title: undefined,
      text: undefined,
      icon: undefined,
      level: undefined,
      collapsable: undefined,
      dismissable: undefined,
      placementNodeIds: [],
      targetNodeId: "continue",
    };
  }

  get context() {
    return {
      [`broadcast-${this.id}`]: { placementNodeIds: this.placementNodeIds, text: this.text },
    };
  }

  get possibleNextNodeIds() {
    return [this.targetNodeId];
  }

  autoAdvance() {
    return true;
  }

  nextNodeId() {
    return this.targetNodeId;
  }

  toProcessedData(context) {
    return {
      title: processText(this.title, context),
      text: processText(this.text, context),
      icon: this.icon,
      level: this.level,
      collapsable: this.collapsable,
      dismissable: this.dismissable,
    };
  }
}
